import React from "react";
import { GiftIcon, LightbulbIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { SectionHeading } from "./SectionHeading";
import { ExpandableList } from "./ExpandableList";
import { bonuses } from "../data/bonuses";
export function BonusesSection() {
  return <section className="bg-surface px-4 py-16 sm:px-6 sm:py-24" id="bonuses" data-id="element-64" data-mp="qt9z81d0nl90">
      <div className="mx-auto max-w-6xl" data-id="element-65" data-mp="14tkr97q2b5vr">
        <div className="mb-5 flex justify-center" data-id="element-66" data-mp="14sj4i5zoouy7">
          <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-alert text-white" data-id="element-67" data-mp="14r80q668nn73">
            <GiftIcon className="h-8 w-8" aria-hidden="true" data-id="element-68" data-mp="1eje1a4ak3cxw" />
          </span>
        </div>
        <SectionHeading title={<>
              5 specialized bonuses — <span className="text-alert" data-id="element-70" data-mp="19mdvluhmcc7b">included</span> with your purchase
            </>} subtitle="These aren't generic downloads or unrelated extras. Each bonus focuses on a practical aspect of reviewing findings, organizing information, or practicing assessment concepts." data-id="element-69" data-mp="1el8booo7bmnq" />

        <div className="mt-14 space-y-16 sm:space-y-20" data-id="element-71" data-mp="3psohc6kvg3mm">
          {bonuses.map((b, i) => <article key={b.number} className="grid items-center gap-8 lg:grid-cols-2 lg:gap-14" data-id="element-72" data-mp="3tu00bt98pqlu" data-mpi={i}>
              <div className={`-mx-4 sm:mx-0 ${i % 2 === 1 ? "lg:order-2" : ""}`} data-id="element-73" data-mp="2np54dqwvk2f">
                <img src={b.image} alt={`${b.title} — bonus mockup`} className="w-full bg-white sm:rounded-3xl" loading="lazy" data-id="element-74" data-mp="7m0d0ixnbki0" />
              </div>

              <div data-id="element-75" data-mp="lcdlcmeg917v">
                <div className="flex flex-wrap items-center gap-3" data-id="element-76" data-mp="lbu1h058o2r7">
                  <span className="rounded-lg bg-alert px-3 py-1.5 font-display text-lg font-bold uppercase tracking-wide text-white" data-id="element-77" data-mp="qb6zmh1k8w93">
                    Bonus #{b.number}
                  </span>
                  <span className="text-sm text-ink-soft" data-id="element-78" data-mp="109e25uv3rbrk">
                    Illustrative reference value: <span className="font-semibold line-through" data-id="element-79" data-mp="10708nqg2m7m4">${b.value}</span>{" "}
                    <strong className="text-success" data-id="element-80" data-mp="aj4lgn6g9ah7">Included</strong>
                  </span>
                </div>
                <h3 className="mt-4 font-display text-3xl font-bold uppercase leading-tight text-ink sm:text-4xl" data-id="element-81" data-mp="5kb76sjc9ffz">
                  {b.title}
                </h3>
                <p className="mt-3 text-lg font-bold leading-snug text-navy-700" data-id="element-82" data-mp="fiqz2xq6wsqj">{b.tagline}</p>
                <p className="mt-3 text-base leading-relaxed text-ink-soft" data-id="element-83" data-mp="tafcr5g37p9m">{b.intro}</p>
                <p className="mt-5 text-sm font-bold uppercase tracking-wide text-ink" data-id="element-84" data-mp="oblxp8l5jq7c">Inside, you'll find:</p>
                <div className="mt-3" data-id="element-85" data-mp="139e8jnfr7qf7">
                  <ExpandableList items={b.items} data-id="element-86" data-mp="yatk0l9v6v6l" />
                </div>
                <div className="mt-6 flex gap-3 rounded-2xl bg-white p-4" data-id="element-87" data-mp="ybl1ytajguee">
                  <LightbulbIcon className="mt-0.5 h-5 w-5 shrink-0 text-navy-700" aria-hidden="true" data-id="element-88" data-mp="3522ei4js8ryo" />
                  <p className="text-sm leading-relaxed text-ink" data-id="element-89" data-mp="303hnmvqf7kmw">
                    <strong data-id="element-90" data-mp="1fjm2wtk71bdu">Why I included it:</strong> {b.why}
                  </p>
                </div>
              </div>
            </article>)}
        </div>

        <div className="mt-16" data-id="element-91" data-mp="1kl1piq20rpyc">
          <CtaButton label="Yes — include all 5 bonuses" data-id="element-92" data-mp="15v460nf1bofh" />
        </div>
      </div>
    </section>;
}